<template>
  <el-dialog :visible.sync="show" title="三元详细信息" :before-close="closeDialog" width="590px" :close-on-click-modal="false" append-to-body>
    <div class="" v-loading="loading">
      <el-form label-width="120px" :inline="true" ref="form">
        <el-form-item label="设备名" prop="Name">
          <el-input class="input-small" v-model="triplet.extendParam" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="出厂编码" prop="Name">
          <el-input class="input-small" v-model="triplet.FactoryCode" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="资产码" prop="Name">
          <el-input class="input-small" v-model="triplet.assetsCode" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="设备密钥" prop="Name">
          <el-input class="input-small" v-model="triplet.SecrtKey" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="产品密钥" prop="Name">
          <el-input class="input-small" v-model="triplet.PublickKey" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="注册码" prop="Name">
          <el-input class="input-small" v-model="triplet.RegCode" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>

        <el-form-item label="交直流类型" prop="Name">
          <el-input class="input-small" v-model="triplet.TypeName" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>

        <el-form-item label="创建时间" prop="Name">
          <el-input class="input-small" v-model="triplet.CreateTime" :disabled="isDisabled" style="width: 360px"></el-input>
        </el-form-item>
        <div class="flex-end mt-10">
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { GetTripletByAssetsCode } from "@/api/dev_archive.js"

import { formatDate } from "@/utils/tools.js"
export default {
  data() {
    return {
      show: false,
      loading: false,
      isDisabled: true,
      triplet: {}
    }
  },
  props: {},
  watch: {},
  methods: {
    showTripletInfo(assets_code) {
      this.show = true
      this.loading = true
      GetTripletByAssetsCode({ assetsCode: assets_code }).then((res) => {
        this.triplet = res.data
        this.loading = false
      })
    },

    closeDialog() {
      this.show = !this.show
    }
  }
}
</script>
